<template>
    <div class="mainbody modulewrap">
        <div class="banner">
            <div class="bannerimg"><img :src="infodata.banner" /></div>
            <div class="sloganwrap"><div class="realwrap"><div class="slogan"><span v-html="$common.langinfo(infodata.content,infodata.content_en)"></span><span class="line"></span></div></div></div>
        </div>
        <div class="infowrap" v-for="(item,index) in infolist" :key="item.id">

            <div :class="['infobox',((index %2 )==1)?'doublerow':'singlerow']" v-if="item.parinfokindkv<999">
                <div class="maintitle realwrap" v-if="item.parinfokindkv!=9"><div class="word">{{$common.langinfo(item.title,item.title_en)}}</div></div>
                <div class="infomark" v-if="item.parinfokindkv==9">
                    <div class="infomarkbg">
                        <div class="a"></div>
                        <div class="b"></div>
                    </div>
                    <div class="infomarkimg">
                        <img :src="item.imgs" />
                        <div class="infomarkmark"><img src="/images/teatree.png" /></div>
                    </div>

                </div>

                <div class="info1 realwrap" v-else-if="item.parinfokindkv==1">
                    <ul>
                        <li v-for="item2 in item.x_children" :key="item2.id">
                            <span v-html="$common.langinfo(item2.title,item2.title_en).replace('|','<br />')"></span>
                            <div class="ling"></div>
                        </li>
                    </ul>
                    <div class="content editor"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </div>
                <div class="info2 realwrap" v-else-if="item.parinfokindkv==2">
                    <ul>
                        <li v-for="item2 in item.x_children" :key="item2.id">
                            <dl>
                                <dt>{{$common.langinfo(item2.title,item2.title_en)}}</dt>
                                <dd><span v-html="$common.langinfo(item2.content,item2.content_en)"></span></dd>
                            </dl>
                        </li>
                    </ul>
                </div>
                <div class="info3" v-else-if="item.parinfokindkv==3">
                    <div class="content editor realwrap" v-if="!$common.basic.chempty(item.content)"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                    <div class="swiperarrow" v-if="item.x_imgs.length>1">
                        <dl>
                            <dd><a href="#" @click="item.x_direct=2;item.x_indexcur--"><i class="iconfont icon-fanye"></i></a></dd>
                            <dd><a href="#" @click="item.x_direct=1;item.x_indexcur++"><i class="iconfont icon-fanye1"></i></a></dd>
                        </dl>
                    </div>
                    <div class="swiper"><ffswiper :infolist="item.x_imgs" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct"></ffswiper></div>
                </div>
                <div class="info4 realwrap" v-else-if="item.parinfokindkv==4">
                    <div class="content editor" v-if="!$common.basic.chempty(item.content)"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                    <div class="imgbox">
                        <div class="swiperarrow" v-if="item.x_imgs.length>horsestep">
                            <dl>
                                <dd><a href="#" @click="swiperprev(item.id)"><i class="iconfont icon-fanye"></i></a></dd>
                                <dd><a href="#" @click="swipernext(item.id)"><i class="iconfont icon-fanye1"></i></a></dd>
                            </dl>
                        </div>

                        <div class="swiper"><ffswiperimg :ref="'myswiper_'+item.id" :infolist="item.x_imgs" :options="item.x_options" :step="horsestep"></ffswiperimg></div>

                    </div>
                </div>
                <div class="info5 realwrap" v-else-if="item.parinfokindkv==5">
                    <ul>
                        <li v-for="item2 in item.x_imgs" :key="item2.id">
                            <img :src="item2.img" />
                        </li>
                    </ul>
                </div>
                <div class="infomentor realwrap" v-else-if="item.parinfokindkv==8">
                    <div class="mentor">

                        <div class="swiper"><ffswiper :infolist="mentors" :options="item.x_options" :indexcur.sync="item.x_indexcur" :direct.sync="item.x_direct" csscon="item"></ffswiper></div>
                        <div class="swiperarrow" v-if="mentors.length>1">
                            <dl>
                                <dd><a href="#" @click="item.x_direct=2;item.x_indexcur--"><i class="iconfont icon-fanye"></i></a></dd>
                                <dd><a href="#" @click="item.x_direct=1;item.x_indexcur++"><i class="iconfont icon-fanye1"></i></a></dd>
                            </dl>
                        </div>
                    </div>
                    <div class="wall">
                        <img :src="item.imgs" />
                    </div>
                </div>
                <div class="infocollege realwrap" v-else-if="item.parinfokindkv==7">
                    <ul>
                        <li v-for="(item2,index2) in collegelist" :key="item2.id" :class="{b:index2>0}">
                            <router-link :to="item2.url">
                                <img :src="item2.cover" /><br /><span></span>{{$common.langinfo(item2.title,item2.title_en)}}
                                <div class="icon"><i class="iconfont icon-arrow-up-copy"></i></div>
                            </router-link>

                        </li>
                    </ul>
                </div>
            </div>


        </div>
        <div class="infoblank"></div>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data() {
            return {
                infodata: {},
                infolist: [],
                collegelist: [],
                mentorlist: [],
            };
        },
        computed: {
            mentors: function () {
                let _mentors = [];
                this.$common.each(this.mentorlist, item => {

                    let content = '';
                    content += '<div class="intro">';
                    content += '<dl>';
                    content += '<dt><img src="' + item.avator + '" /></dt>';
                    content += '<dd class="a">' + item.title + '</dd>';
                    content += '<dd class="b editor">' + item.contenthome + '</dd>';
                    content += '</dl>';
                    content += '</div>';
                    content += '<div class="img"><img src="' + item.imgs.split(',')[0] + '" /></div>';
                    content += '</div>';

                    let content_en = '';
                    content_en += '<div class="item">';
                    content_en += '<div class="intro">';
                    content_en += '<dl>';
                    content_en += '<dt><img src="' + item.avator + '" /></dt>';
                    content_en += '<dd class="a">' + item.title_en + '</dd>';
                    content_en += '<dd class="b editor">' + item.contenthome_en + '</dd>';
                    content_en += '</dl>';
                    content_en += '</div>';
                    content_en += '<div class="img"><img src="' + item.imgs.split(',')[0] + '" /></div>';

                    let _mentor = { "id": item.id, "content": content, "content_en": content_en };
                    _mentors.push(_mentor);
                });

                return _mentors;
            },
            horsestep: function () {
                return this.$store.getters.istiny ? 2 : 3;
            }

        },
        methods: {
            swiperprev: function (id) {
                this.$nextTick(function () {
                    this.$refs['myswiper_' + id][0].goprev();
                });
            },
            swipernext: function (id) {
                this.$nextTick(function () {
                    this.$refs['myswiper_' + id][0].gonext();
                });
            }
        },
        mounted() {

            this.$common.fetch({ 'act': 'tea_home' }, res => {
                this.infodata = res.infodata;
                this.$common.each(res.infodatainfo, (item) => {
                    item.x_children = res.infodatainfosub.filter(item2 => item2.infoid == item.id);
                    item.x_haschild = (this.$common.basic.chempty(item.x_children));
                    item.x_indexcur = 0;
                    item.x_options = { 'type': item.parinfokindkv == 3 ? 'image' : 'content', 'isautoplay': item.parinfokindkv == 4 };
                    item.x_direct = 1;
                    let _imgs = item.imgs.split(',');
                    let x_imgs = [];
                    this.$common.each(_imgs, (item2, index2) => {
                        x_imgs.push({ "id": index2, "img": item2 });
                    });
                    item.x_imgs = x_imgs;
                });
                this.infolist = res.infodatainfo;
                this.$common.each(res.infodatacollege, (item) => {
                    item.url = "/college/" + item.alias;
                });
                this.collegelist = res.infodatacollege;
                this.mentorlist = res.infodatamentor;

            });
        }

    }
</script>
